import { render } from "./Activity-Icon.vue?vue&type=template&id=bab8b7ce&scoped=true"
import script from "./Activity-Icon.vue?vue&type=script&lang=js"
export * from "./Activity-Icon.vue?vue&type=script&lang=js"

import "./Activity-Icon.vue?vue&type=style&index=0&id=bab8b7ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bab8b7ce"]])

export default __exports__